import { FC } from "react";
import Modal from "react-modal";
import { Teacher } from "src/Models/Class";

interface ModalProps {
  modalIsOpen: boolean;
  closeModal: () => void;
  teacher: Teacher | undefined;
}

const TeacherModal: FC<ModalProps> = ({ modalIsOpen, closeModal, teacher }) => {
  return (
    <Modal
      className="teachers_popup"
      isOpen={modalIsOpen}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <div className="teacher_container">
        <div className="teacher_title">{teacher?.name}</div>
        <div className="teacher_image_container">
          {" "}
          <img
            className="teacher_img"
            src={teacher?.image_url}
            alt={teacher?.name}
          />
        </div>
        <div className="teacher_name">{teacher?.name}</div>
        <p
          className="teacher_bio"
          dangerouslySetInnerHTML={{ __html: teacher?.bio || "" }}
        />
        <div className="teacher_bio_url">
          <br></br>
          <a href={teacher?.bio_url} target="_blank" rel="noreferrer">View Teacher Page</a>
        </div>
      </div >
      <div className="teacher_buttons">
        <button onClick={closeModal}>Close</button>
      </div>
    </Modal >
  );
};

export default TeacherModal;
